<template>
  <div class="kpt-confirm-sync">
    <p class="title is-5 is-uppercase">Confirm Remote Sync</p>

    <div>
      <p class="subtitle is-6">The Sync process will update network provider state to match Kymeta configured state. This process proceeds in the background, and may take several minutes. Are you sure you would like to do this?</p>
    </div>

    <div class="buttons">
      <b-button type="is-primary is-outlined" size="is-small" icon-left="check" :loading="syncing" :disabled="syncing" @click="syncToHub">Yes</b-button>
      <b-button type="is-primary is-outlined" size="is-small" icon-left="times" :disabled="syncing" @click="$emit('cancel')">No</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmRemoteSync',
  methods: {
    async syncToHub() {
      this.syncing = true;
      await this.$store.dispatch('syncRemoteToHub', { id: this.remote.id });
      this.syncing = false;
      // emit success to inform parent component
      this.$emit('success');
    }
  },
  computed: {
    remote() {
      return this.$store.state.remotes.remote;
    }
  },
  data() {
    return {
      syncing: false
    }
  }
}
</script>

<style lang="scss" scoped>
.kpt-confirm-sync {
  p {
    margin-bottom: 15px;
  }

  h5 {
    margin-bottom: 15px;
  }
}
</style>
